<template>
	<div class="layout-footer">
		<span class="footer-text" style="margin-right: 5px"><b>&copy;2021 - Facultad de Negocios Campus IV UNACH </b> &nbsp;&nbsp;|&nbsp;&nbsp;  <b>Sistema Administrador de Curriculum Vitae Docentes (Formato CONAIC) </b></span>				
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

</style>